import { render } from "./ImageCropper.vue?vue&type=template&id=3c510184&scoped=true"
import script from "./ImageCropper.vue?vue&type=script&lang=js"
export * from "./ImageCropper.vue?vue&type=script&lang=js"

import "./ImageCropper.vue?vue&type=style&index=0&id=3c510184&scoped=true&lang=css"

import exportComponent from "F:\\N\\nawaf\\nawaf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c510184"]])

export default __exports__